import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { GenericInputModule } from '@sla-ng/ui-material';
import { PlannedSaleVolumeDialogComponent } from './planned-sale-volume-dialog.component';

export * from './planned-sale-volume-dialog.component';
@NgModule({
    declarations: [ PlannedSaleVolumeDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        TranslateModule,
        GenericInputModule,
        MatMomentDateModule,
        MatProgressBarModule,
    ],
})
export class PlannedSaleVolumeDialogModule {
}
